export const initialState = ({ Links } = {}) => ({
  links: Links,
  newLinkIsVisible: false,
  currentLink: null,
  selectTemplatesIsVisible: false,
  selectedTemplateIndex: 0,
});

export const types = {
  SET_LINKS: 'SET_LINKS',
  SET_NEW_LINK_IS_VISIBLE: 'SET_NEW_LINK_IS_VISIBLE',
  SET_CURRENT_LINK: 'SET_CURRENT_LINK',
  SET_SELECT_TEMPLATES_IS_VISIBLE: 'SET_SELECT_TEMPLATES_IS_VISIBLE',
  SET_SELECTED_TEMPLATE_INDEX: 'SET_SELECTED_TEMPLATE_INDEX',
  SET_MULTI: 'SET_MULTI',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_LINKS:
      return { ...state, links: payload };
    case types.SET_NEW_LINK_IS_VISIBLE:
      return { ...state, newLinkIsVisible: payload };
    case types.SET_CURRENT_LINK:
      return { ...state, currentLink: payload };
    case types.SET_SELECT_TEMPLATES_IS_VISIBLE:
      return { ...state, selectTemplatesIsVisible: payload };
    case types.SET_SELECTED_TEMPLATE_INDEX:
      return { ...state, selectedTemplateIndex: payload };
    case types.SET_MULTI:
      return { ...state, ...payload };
    default:
      throw new Error();
  }
};
